import { render, staticRenderFns } from "./titleStyle.vue?vue&type=template&id=f807c484&scoped=true&"
import script from "./titleStyle.vue?vue&type=script&lang=js&"
export * from "./titleStyle.vue?vue&type=script&lang=js&"
import style0 from "./titleStyle.vue?vue&type=style&index=0&id=f807c484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f807c484",
  null
  
)

export default component.exports